"use strict";
exports.__esModule = true;
exports.toTile = void 0;
var utils_1 = require("@lglp/utils");
var tile_1 = require("../../types/partials/tile");
var fields_1 = require("../fields");
var TILE_FORMAT_PRISMIC_TO_LGLP = {
    Carré: tile_1.TileFormat.square,
    Rectangle: tile_1.TileFormat.rectangle
};
var TILE_TYPE_PRISMIC_TO_LGLP = {
    Image: tile_1.TileType.image,
    Gif: tile_1.TileType.gif,
    Sondage: tile_1.TileType.survey
};
var toTile = function (data, logger) {
    var prismicTile = utils_1.unprefix('tile', data);
    if (prismicTile) {
        return utils_1.compact({
            format: logger.toConstValue(prismicTile.format, TILE_FORMAT_PRISMIC_TO_LGLP),
            type: logger.toConstValue(prismicTile.type_content, TILE_TYPE_PRISMIC_TO_LGLP),
            square_image: fields_1.toImage(prismicTile.square_image, logger),
            rectangle_image: fields_1.toImage(prismicTile.rectangle_image, logger)
        });
    }
};
exports.toTile = toTile;
//# sourceMappingURL=tile.js.map